import { client } from "@/config/client"

export type GetLpScoreResponse = { score: number }

export function getScore(id: string) {
  return client.get<GetLpScoreResponse>(`/v1/learning-paths/${id}/score`)
}
